var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isReady
    ? _c("loading-box")
    : _c("div", [
        _c("div", { staticClass: "col-12 primary header" }, [
          _c("div", { staticClass: "pull-left d-inline-block" }, [
            _c(
              "span",
              { staticClass: "title" },
              [
                _c("resource-string", {
                  attrs: { name: "MediaLibrary_Browser_Title" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pull-right d-inline-block" },
            [
              _vm.canDelete
                ? [
                    _vm.selectedFile
                      ? _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                return _vm.deleteFile(
                                  _vm.currentFolder,
                                  _vm.selectedFile
                                )
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-trash control-btn" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedFolder
                      ? _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                return _vm.deleteFolder(_vm.selectedFolder)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-trash control-btn" })]
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      _vm.displaySearch = !_vm.displaySearch
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-search control-btn" })]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      return _vm.growl("Closing")
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-times control-btn" })]
              )
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm.displaySearch
          ? _c("div", { staticClass: "col-12 search-container my-3" }, [
              _c("div", { staticClass: "row justify-content-center" }, [
                _c("div", { staticClass: "col-8" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      placeholder: _vm.resource(
                        "MediaLibrary_Search_Placeholder"
                      )
                    },
                    domProps: { value: _vm.search },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasFolder
          ? _c("div", { staticClass: "col-12 body" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("media-library-breadcrumbs", {
                      attrs: { "base-folder": _vm.currentFolder },
                      on: {
                        "folder-selected": function($event) {
                          _vm.currentFolder = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row media-library-content-listing" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    !_vm.search && _vm.canWrite
                      ? _c(
                          "div",
                          { staticClass: "media-item-container" },
                          [
                            _c("media-library-new-folder", {
                              attrs: {
                                "parent-id": _vm.currentFolder.id,
                                "media-library-id":
                                  _vm.currentFolder.mediaLibraryId
                              },
                              on: {
                                "folder-created": function($event) {
                                  return _vm.folderCreated(
                                    $event,
                                    _vm.currentFolder
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.displayedFolders, function(folder) {
                      return _c(
                        "div",
                        { key: folder.id, staticClass: "media-item-container" },
                        [
                          _c("media-library-folder", {
                            class: { selected: folder === _vm.selectedFolder },
                            attrs: { name: folder.name, id: folder.id },
                            on: {
                              "folder-selected": function($event) {
                                _vm.selectedFolder = folder
                              },
                              "folder-navigated": function($event) {
                                _vm.currentFolder = folder
                              },
                              "folder-renamed": function($event) {
                                folder.name = $event
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.displayedFiles, function(file) {
                      return _c(
                        "div",
                        { key: file.id, staticClass: "media-item-container" },
                        [
                          _c("media-library-file", {
                            class: { selected: file === _vm.selectedFile },
                            attrs: { name: file.name, id: file.id },
                            on: {
                              "file-selected": function($event) {
                                _vm.selectedFile = file
                              },
                              "file-picked": function($event) {
                                return _vm.pickFile(_vm.selectedFile)
                              },
                              "file-renamed": function($event) {
                                file.name = $event
                              }
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 primary footer" }, [
          _vm.canWrite
            ? _c("div", { staticClass: "file-upload-container" }, [
                _c("input", {
                  ref: "newMediaFile",
                  attrs: { type: "file" },
                  on: {
                    change: function($event) {
                      return _vm.createFile(
                        _vm.currentFolder,
                        _vm.$refs.newMediaFile.files[0]
                      )
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedFile
            ? _c(
                "button",
                {
                  staticClass: "btn btn-default pull-right",
                  on: {
                    click: function($event) {
                      return _vm.pickFile(_vm.selectedFile)
                    }
                  }
                },
                [
                  _c("resource-string", {
                    attrs: { name: "MediaLibrary_InsertFile_Button" }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }